import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    placas: '',
    placasTemp: '',
    afericao: '',
    veiculo: '',
    pneusRodando: '',
    pneusDescarte: '',
    pneusRecapadora: '',
    pneusEstoque: '',
    percentualAfericaoMes: '',
    percentualCalibragemMes: '',
    pneusBD: [],
    filesUpload: '',
    params: '',
    placasDescartes: [],
    total: 0,
    pagination: {
      currentPage: 1,
      perPage: 12
    },
    getPlacasDescartes: [],
    placaDescarte: [],
    fornecedores: [],
    motivos: [],
    servicos: [],
    filtersTemp: [],
  },

  getters: {
    getPlacas: (state) => state.placas,
    getAfericao: (state) => state.afericao,
    getVeiculo: (state) => state.veiculo,
    filters: (state) => state.filters,

    getPneusRodando: (state) => state.pneusRodando,
    getPneusDescarte: (state) => state.pneusDescarte,
    getPneusRecapadora: (state) => state.pneusRecapadora,
    getPneusEstoque: (state) => state.pneusEstoque,

    getPercentualAfericaoMes: (state) => state.percentualAfericaoMes,
    getPercentualCalibragemMes: (state) => state.percentualCalibragemMes,

    getPneusBD: (state) => state.pneusBD,

    getParams: (state) => state.params,
    pagination: (state) => state.pagination,
    getPlacasDescartes: (state) => state.getPlacasDescartes,

    page: (state) => (page) => state.placasDescartes[page],
    total: (state) => state.total,

    getPlacaDescarte: (state) => state.placaDescarte,

    getFornecedores: (state) => state.fornecedores,

    getMotivos: (state) => state.motivos,
    getServicos: (state) => state.servicos,
    getFilters: (state) => state.filters,
    getFiltersTemp: (state) => state.filtersTemp,
  },
 
  actions: {
    async uploadFilesAfericao({ commit, state }, { data, dataPneu }) {
      try {

        // const params = {
        //   data: data,
        //   dataPneu: dataPneu
        // }

        const response = await api.post(`borracharia/uploadFilesAfericao/${dataPneu.nr_placa}/${dataPneu.nr_seq_evento}`, data)

        return response
      } catch (error) {
        throw Error(error)
      }
    },
    async inserePneu({ commit }, { data }) {
      try {
        const response = await api.post('borracharia/inserePneu', { ...data })

        // commit('setPneus', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },
    async getPneusBD({ commit }) {
      try {
        commit('setPneus', [])
        const response = await api.get('borracharia/getPneusBD')

        commit('setPneus', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getDashboard({ commit, state }) {
      try {
        state.pneusRodando = 'loading'
        state.pneusDescarte = 'loading'
        state.pneusRecapadora = 'loading'
        state.pneusEstoque = 'loading'

        const response = api.get('borracharia/getDashboard').then(response => {
          const arrayRodando = []
          const arrayDescarte = []
          const arrayRecapadora = []
          const arrayEstoque = []



          response.data.informacoes.forEach(item => {
            if (item.nr_placa != null) {
              arrayRodando.push(item)
            }

            if (item.des_data != null) {
              arrayDescarte.push(item)
            }

            if (item.rec_dataenvio != null) {
              arrayRecapadora.push(item)
            }

            if (item.nr_placa == null && item.des_data == null && item.rec_dataenvio == null) {
              arrayEstoque.push(item)
            }

          })


          state.percentualAfericaoMes = response.data.afericoes_mes
          state.percentualCalibragemMes = response.data.calibragem_mes

          state.pneusRodando = arrayRodando
          state.pneusDescarte = arrayDescarte
          state.pneusRecapadora = arrayRecapadora
          state.pneusEstoque = arrayEstoque
        })



        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async removerPneu({ commit }, { data }) {
      try {
        const response = await api.post('borracharia/removerPneu', { ...data })

        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async submitAfericao({ commit }, { data }) {
      try {
        const response = await api.post('borracharia/submitAgericao', { ...data })

        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async submitCalibragem({ commit }, { data }) {
      try {
        const response = await api.post('borracharia/submitCalibragem', { ...data })

        return response
      } catch (error) {
        throw Error(error)
      }
    },

    
    async fetchFromPlacas({ commit, state }) {
      try {
        const response = await api.get(`borracharia/getPlacas`)

        commit('setPlacas', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async fetchPlacasDescartes({ commit, state }) {
      try {
        const pagination = {
          per_page: state.pagination.perPage,
          page: state.pagination.currentPage
        }

        commit('setData', { pageNumber: pagination.page, data: 'loading' })

        const params = {
          ...pagination,
          ...state.filters
        }

        const response = await api.get(`borracharia/fetchPlacasDescartes`, { params: params })

        // console.log(response.data)

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })

        // commit('setDescartes', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getFiltros({ commit, state }) {
      try {
        const params = {
          ...state.filters
        }

        const response = await api.get(`borracharia/getFiltros`, { params: params })

        // commit('setFilters', response.data)
        commit('setFiltersTemp', response.data)
        // commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })

        // commit('setDescartes', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },


    async getPlacaMilimetragem({ commit, state }, { data }) {
      try {
        const params = {
          ...data
        }

        const response = await api.get(`borracharia/getPlacaMilimetragem`, { params: params })

        commit('setPlacaAfericao', response.data)
        commit('setParams', data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },


    async getPlacaMovimentacoes({ commit, state }, { data }) {
      try {
        const params = {
          ...data
        }

        const response = await api.get(`borracharia/getPlacaMovimentacoes`, { params: params })

        commit('setPlacaAfericao', response.data)
        commit('setParams', data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getFromDescarte({ commit, state }, searchQuery = '') {
      try {
        const response = await api.get(`borracharia/getFromDescarte`)

        commit('setPlacaDescarte', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getFornecedoresDescartes({ commit, state }, searchQuery = '') {
      try {
        const response = await api.get(`borracharia/getFornecedoresDescartes`, {
          params: {
            search: searchQuery, // Passa o termo de pesquisa para o backend
          },
        })

        commit('setFornecedoresDescartes', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async postDescarte({ commit, state }, { data }) {
      try {
        const response = await api.post(`borracharia/postDescarte`, { ...data })

        return response
      } catch (error) {
        throw Error(error)
      }
    },
  },

  mutations: {
    setPlacaDescarte(state, data) {
      state.motivos = data.motivos
      state.servicos = data.servicos
    },

    setFornecedoresDescartes(state, data){
      state.fornecedores = data      
    },

    setFiltersTemp(state, filters) {
      state.filtersTemp = filters
    },

    setData(state, { pageNumber, data, total }) {
      if (total) {
        state.total = total
      }

      state.placasDescartes[pageNumber] = data

      state.placasDescartes = [
        ...state.placasDescartes
      ]
    },
    setParams(state, params) {
      state.params = params
    },

    setPlacas(state, placas) {
      state.placasTemp = placas
      state.placas = placas
    },

    setPneus(state, pneus) {
      state.pneusBD = pneus
    },

    setPlacaAfericao(state, placa) {
      state.afericao = []
      state.afericao = placa.placa
      state.veiculo = placa.veiculo
    },

    setFilterPlaca(state, placa) {
      state.placas = state.placasTemp.filter(element => element.nr_placa == placa)
    },

    setFilters(state, {filters}) {
      state.filters = {
        ...filters
      }
    },

    clearFilterPlaca(state) {
      state.placas = state.placasTemp
    },
    setFilesUpload(state, files) {
      state.filesUpload = files
    },
    setCurrentPage(state, { page }) {
      state.pagination.currentPage = page
    },

  }
}
